import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import VueMarkdown from 'vue-markdown';
import RollTable from '@/components/RollTable.vue';
import Loading from '@/components/Loading.vue';
import BackButton from '@/components/BackButton.vue';
const backgroundModule = namespace('backgrounds');
const featModule = namespace('feats');
let CharactersBackgroundsDetail = class CharactersBackgroundsDetail extends Vue {
    created() {
        this.fetchBackgrounds();
        this.fetchFeats();
    }
    get title() {
        return this.backgroundName + Vue.prototype.$titleSuffix;
    }
    get background() {
        return this.backgrounds.find(({ name }) => name === this.backgroundName);
    }
    get featsWithModals() {
        return this.background && this.background.featOptions.map(({ roll, name }) => {
            const feat = this.feats.find(feat => feat.name === name);
            return {
                roll,
                text: name,
                modalContent: feat && feat.text
            };
        });
    }
    mapToText(options) {
        return options && options.map(({ name, roll, description }) => ({
            text: (name && description) ? `${name}. ${description}` : (name || description),
            roll
        }));
    }
};
__decorate([
    backgroundModule.State
], CharactersBackgroundsDetail.prototype, "backgrounds", void 0);
__decorate([
    backgroundModule.Action
], CharactersBackgroundsDetail.prototype, "fetchBackgrounds", void 0);
__decorate([
    featModule.State
], CharactersBackgroundsDetail.prototype, "feats", void 0);
__decorate([
    featModule.Action
], CharactersBackgroundsDetail.prototype, "fetchFeats", void 0);
__decorate([
    Prop(String)
], CharactersBackgroundsDetail.prototype, "backgroundName", void 0);
__decorate([
    Prop(Boolean)
], CharactersBackgroundsDetail.prototype, "isHidingBack", void 0);
CharactersBackgroundsDetail = __decorate([
    Component({
        components: {
            RollTable,
            BackButton,
            VueMarkdown,
            Loading
        }
    })
], CharactersBackgroundsDetail);
export default CharactersBackgroundsDetail;
